<script>
  import { onMount } from 'svelte';
  import { browser } from '$app/environment';
  
  let totalSpins = 0;
  let loading = true;
  let error = false;
  
  onMount(async () => {
    if (browser) {
      try {
        const response = await fetch('/api/stats');
        const data = await response.json();
        
        if (data.success) {
          totalSpins = data.total_spins;
        } else {
          error = true;
        }
      } catch (error) {
        console.error('Error fetching spin stats:', error);
        error = true;
      } finally {
        loading = false;
      }
    }
  });
</script>

<footer>
  <div class="container">
    <div class="footer-content">
      <div class="footer-section">
        <h3>SpinWheelNames</h3>
        <p>Free online random name picker and wheel spinner tool. Perfect for classrooms, contests, team selection, and decision making.</p>
      </div>
      
      <div class="footer-section">
        <h3>Popular Wheels</h3>
        <ul>
          <li><a href="/wheel-of-names">Wheel of Names</a></li>
          <li><a href="/random-wheel-generator">Random Wheel Generator</a></li>
          <li><a href="/spinning-wheel-picker">Spinning Wheel Picker</a></li>
          <li><a href="/spin-wheel-app">Spin Wheel App</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3>Use Cases</h3>
        <ul>
          <li><a href="/classroom-name-picker">Classroom Name Picker</a></li>
          <li><a href="/contest-winner-picker">Contest Winner Picker</a></li>
          <li><a href="/random-team-generator">Random Team Generator</a></li>
          <li><a href="/random-decision-maker">Random Decision Maker</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3>Information</h3>
        <ul>
          <li><a href="/about">About</a></li>
          <li><a href="/faq">FAQ</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
        </ul>
      </div>
    </div>
    
    <div class="footer-middle">
      <h3>Popular Searches</h3>
      <div class="tag-cloud">
        <a href="/wheel-of-names">wheel of names</a>
        <a href="/random-wheel-generator">random wheel generator</a>
        <a href="/spinning-wheel-picker">spinning wheel picker</a>
        <a href="/spin-wheel-app">spin wheel app</a>
        <a href="/">spin wheel</a>
        <a href="/random-wheel-generator">wheel spinner generator</a>
        <a href="/wheel-of-names">name picker wheel</a>
        <a href="/spinning-wheel-picker">random spinner wheel</a>
        <a href="/classroom-name-picker">classroom name picker</a>
        <a href="/contest-winner-picker">prize wheel</a>
        <a href="/random-team-generator">team generator wheel</a>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>&copy; {new Date().getFullYear()} SpinWheelNames. All rights reserved.</p>
      <p>No registration. Completely free.</p>
      <p class="spin-counter">
        Total wheels spun: 
        {#if loading}
          <span class="spin-count loading">Loading...</span>
        {:else if error}
          <span class="spin-count">0</span>
        {:else}
          <span class="spin-count">{totalSpins.toLocaleString()}</span>
        {/if}
      </p>
    </div>
  </div>
</footer>

<style>
  footer {
    background-color: #f8f9fa;
    padding: 3rem 0 1.5rem;
    margin-top: 3rem;
    border-top: 1px solid #e0e0e0;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
  }
  
  .footer-section h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #2c3e50;
  }
  
  .footer-section p {
    color: #555;
    line-height: 1.5;
  }
  
  .footer-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-section li {
    margin-bottom: 0.5rem;
  }
  
  .footer-section a {
    color: #3498db;
    text-decoration: none;
    transition: color 0.2s;
  }
  
  .footer-section a:hover {
    color: #2980b9;
    text-decoration: underline;
  }
  
  .footer-middle {
    border-top: 1px solid #e0e0e0;
    padding-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .footer-middle h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #2c3e50;
    text-align: center;
  }
  
  .tag-cloud {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
  }
  
  .tag-cloud a {
    display: inline-block;
    padding: 0.3rem 0.7rem;
    background-color: #e9f2fb;
    border-radius: 4px;
    color: #3498db;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.2s;
  }
  
  .tag-cloud a:hover {
    background-color: #d4e6f7;
    color: #2980b9;
  }
  
  .footer-bottom {
    border-top: 1px solid #e0e0e0;
    padding-top: 1.5rem;
    text-align: center;
    color: #777;
    font-size: 0.9rem;
  }
  
  .footer-bottom p {
    margin: 0.5rem 0;
  }
  
  .spin-counter {
    font-size: 0.9rem;
    color: #555;
    margin-top: 1rem;
  }
  
  .spin-count {
    font-weight: bold;
    color: #3498db;
  }
  
  .spin-count.loading {
    color: #999;
    font-style: italic;
  }
  
  @media (max-width: 767px) {
    footer {
      padding: 1.5rem 0 1rem;
      margin-top: 1.5rem;
    }
    
    .footer-content {
      grid-template-columns: 1fr;
      gap: 1rem;
      margin-bottom: 1rem;
    }
    
    .footer-section {
      text-align: center;
    }
    
    .footer-section h3 {
      font-size: 1.1rem;
      margin-bottom: 0.5rem;
    }
    
    .footer-section p {
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
    }
    
    .footer-section li {
      margin-bottom: 0.3rem;
    }
    
    .footer-middle {
      padding-top: 1rem;
      margin-bottom: 1rem;
    }
    
    .footer-bottom {
      padding-top: 1rem;
      font-size: 0.8rem;
    }
  }
</style>